<template>
    <div class="app-wrapper" :data-theme="theme">
        <component :is="layout" v-if="layout">
            <router-view></router-view>
        </component>
        <PolicyModal
            :is-open="isOpenPolicy"
            :is-show-close-btn="false"
            @accept-policy="onAcceptPolicy"
        />
        <!-- <div class="fixed bottom-1 left-1 z-50 text-gray text-xs ">
      <div>
        App v. <span>{{ systemStore.getAppVersion }}</span>
      </div>
      <div>
        Api v. <span>{{ systemStore.getApiVersion }}</span>
      </div>
    </div> -->
    </div>
</template>

<script setup>
import { markRaw, onMounted, ref, watch } from "vue";

import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

import { useSystemStore } from "@/stores/systemStore";
import { useAuthStore } from "./stores/authStore";
import { useCartStore } from "./stores/cartStore";

import { theme } from "@/services/getSiteTheme";

import { setupInterceptors } from "@/axios";

import LoginPageLayout from "@/layouts/LoginPageLayout.vue";
import EmptyHeaderLayout from "@/layouts/EmptyHeaderLayout.vue";
import EmptyLayout from "@/layouts/EmptyLayout.vue";
import MainLayout from "@/layouts/MainLayout.vue";
import PocketHeaderLayout from "@/layouts/PocketHeaderLayout.vue";
import ClearLayout from "@/layouts/ClearLayout.vue";
import FrameLayout from "@/layouts/FrameLayout.vue";
import DocsLayout from "@/layouts/DocsLayout.vue";

import PolicyModal from "@/components/policy/PolicyModal.vue";

import { useRecaptchaProvider } from "vue-recaptcha/head";
import { isInFrame } from "utils/isInFrame";

useRecaptchaProvider();

const route = useRoute();
const layout = ref(null);
const { locale } = useI18n();
const systemStore = useSystemStore();
const isOpenPolicy = ref(false);

const changeLayout = (layoutString) => {
    const lookup = {
        PocketHeaderLayout,
        LoginPageLayout,
        MainLayout,
        EmptyHeaderLayout,
        EmptyLayout,
        ClearLayout,
        FrameLayout,
        DocsLayout,
    };

    layout.value = markRaw(lookup[layoutString]);
};

const onAcceptPolicy = () => {
    localStorage.setItem("policy", true);
    isOpenPolicy.value = false;
};

const setLocale = () => {
    const localeMemory = localStorage.getItem("locale");

    if (localeMemory) locale.value = localeMemory;
};

watch(route, () => {
    changeLayout(route.meta.layout + "Layout");
});

const setThemeToBody = () => {
    document.body.setAttribute("data-theme", theme);
};

setLocale();
onMounted(async () => {
    setThemeToBody();
    const authStore = useAuthStore();
    const cartStore = useCartStore();

    systemStore.loadApiLivenes();
    setupInterceptors(authStore);

    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
        authStore.setUser(user);
        cartStore.syncCarts();
        // await cartStore.loadCart();
    } else {
        cartStore.loadLocalCart();
        await authStore.loginMobileApp();
    }
    const isMobile = window.navigator.userAgent === "pricol";
    const isPolicyAgree = isMobile ? true : localStorage.getItem("policy");
    if (!isPolicyAgree && !isInFrame()) isOpenPolicy.value = true;
});
</script>
